import showMoreTeamMembers from './show-more-team-members';

const showMoreTeamMembersConfig = {
  name: 'showMoreTeamMembers',
  class: showMoreTeamMembers,
  querySelector: {
    showMoreTrigger: '.show-more__button',
    contentToShow: '.two-column-block__show-more-content',
  },
  options: {},
};

export default showMoreTeamMembersConfig;
